import request from '@/utils/request';

export default {
  list(params) {
    return request({ url: 'business', params });
  },
  detail(params) {
    return request({ url: 'business/detail', params });
  },
  create(data) {
    return request({ url: 'business/create', data, method: 'post' });
  },
  update(data) {
    return request({ url: 'business/update', data, method: 'post' });
  },
  remove(data) {
    return request({ url: 'business/remove', data, method: 'post' });
  }
};
